import { useContext } from "react";

import { ShipmentResourcesContext } from "../context/Resources";

export const useShipmentResourcesContext = () => {
  const context = useContext(ShipmentResourcesContext);

  return context;
};
